import React, { useEffect } from 'react'
import { PageContainer } from 'pages/utils'
import { ViewerTabTable } from 'components'
import { Props } from './types'
import { VIEWERS_STORE, ViewerPageTabTypes } from 'store'
import { inject } from 'mobx-react'
import { FiltersLine } from './FiltersLine'
import { TabButtonsLine } from './TabButtonsLine'
import { totalWatchColumns, TotalWatchColEnums } from './total-watch-columns'
import { observer } from 'mobx-react-lite'
import { TotalSpendColEnums, totalSpendColumns } from './total-spend-columns'
import { TitleLine } from './TitleLine'
import { ViewerDetails } from './ViewerDetails'
import { TotalInteractionColEnums, totalInteractionColumns } from './total-interaction-columns'
import { TotalAddRevenueColEnums, totalAddRevenueColumns } from './total-add-revenue-columns'
import { ViewerGdprSection } from './ViewerGdprSection/ViewerGdprSection'

const ViewerInfoPageComponent = (props: Props) => {
  const {
    match: { params: { id } },
    [VIEWERS_STORE]: {
      currentViewer: viewer,
      viewerPageSelectedTab: selectedTab,
      loadViewerDetails,
      loadDataForViewerPageTab,
      viewerPageTableRows,
      viewerPageColKeysForCurrentTab
    }
  } = props
  useEffect(() => {
    if (!viewer) return
    loadDataForViewerPageTab()
  }, [viewer, loadDataForViewerPageTab, selectedTab])

  if (!viewer) {
    loadViewerDetails(id)
    return null
  }

  return (
    <PageContainer preset='grey'>

      <ViewerDetails />

      <ViewerGdprSection />

      <TabButtonsLine />

      <TitleLine />

      <FiltersLine key={selectedTab} />

      {selectedTab === ViewerPageTabTypes.TOTAL_WATCH_VIDEO &&
        <ViewerTabTable<TotalWatchColEnums>
          colKeys={viewerPageColKeysForCurrentTab as TotalWatchColEnums[]}
          columns={totalWatchColumns}
          rows={viewerPageTableRows}
        />}

      {selectedTab === ViewerPageTabTypes.TOTAL_INTERACTION_TIME &&
        <ViewerTabTable<TotalInteractionColEnums>
          colKeys={viewerPageColKeysForCurrentTab as TotalInteractionColEnums[]}
          columns={totalInteractionColumns}
          rows={viewerPageTableRows}
        />}

      {selectedTab === ViewerPageTabTypes.ADD_REVENUE &&
        <ViewerTabTable<TotalAddRevenueColEnums>
          colKeys={viewerPageColKeysForCurrentTab as TotalAddRevenueColEnums[]}
          columns={totalAddRevenueColumns}
          rows={viewerPageTableRows}
        />}

      {selectedTab === ViewerPageTabTypes.TOTAL_SPEND &&
        <ViewerTabTable<TotalSpendColEnums>
          colKeys={viewerPageColKeysForCurrentTab as TotalSpendColEnums[]}
          columns={totalSpendColumns}
          rows={viewerPageTableRows}
        />}
    </PageContainer>
  )
}

const ViewerInfoPage = inject(VIEWERS_STORE)(observer(ViewerInfoPageComponent))
export { ViewerInfoPage }
